import React, { useState, useEffect } from 'react';
import addToFavorites from "../assets/addToFavorites.png";
import favorite from "../assets/favorites.png";
import styles from "./FavoritesButton.module.css";
import { useSharedState } from '../hooks/useSharedState';

interface Props {
  eventId: number;
}

const FavoriteButton: React.FC<Props> = ({ eventId }) => {
  const [isFav, setIsFav] = useState(false);
  const [favorites, setFavorites] = useSharedState('favoriteEvents', '');

  const handleToggle = () => {
    const current = favorites;
    const favs = current ? JSON.parse(current) : [];

    let updated;
    if (favs.includes(eventId)) {
      updated = favs.filter((id: number) => id !== eventId);
      
    } else {
      updated = [...favs, eventId];
      
    }
    setFavorites(JSON.stringify(updated));
  };

  useEffect(() => {
    
    setIsFav(favorites && JSON.parse(favorites).includes(eventId))
    
  }, [favorites, eventId]);

  return (

    <div className={styles.favoriteButton} aria-label={isFav ? "Retirer des favoris" : "Ajouter aux favoris"} title={isFav ? "Retirer des favoris" : "Ajouter aux favoris"} onClick={handleToggle}>

        <div className={(isFav ? [styles.button, styles.selected] : [styles.button]).join(' ')}>
            <div className={styles.circle}></div>
            <div className={styles.outline}></div>
            <img src={isFav? favorite : addToFavorites} alt="favoris"/>
        </div>

    </div>
  );
};

export default FavoriteButton;
